import { COMICS } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import SectionHeading from '@/components/base/SectionHeading';

export default function EditorsPicks() {
  const picks = COMICS.filter((c) => c.featured);
  return (
    <section id="editors-picks" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="编辑精选"
          title="本周必看的入坑佳作"
          desc="漫画岛编辑团队从海量作品中精心筛选，每一部都值得你花时间慢慢品味。"
          to="/category/reXue"
          linkText="浏览更多精选"
        />
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {picks.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </div>
    </section>
  );
}